import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DirectoryService } from '../services/directory.service';

@Component({
  selector: 'app-directory',
  templateUrl: './directory.component.html',
  styleUrls: ['./directory.component.css']
})
export class DirectoryComponent implements OnInit {

  constructor(private router: Router, private directoryService : DirectoryService) {
  	//console.log('I am in Directory Component');
  	var currenturl = window.location.hostname;    
    var nameSplit = currenturl.split(".");
    var isLocalhost = currenturl === 'localhost' || currenturl.endsWith('.localhost') || currenturl === '127.0.0.1';
    if((nameSplit[0].toLowerCase() == 'library' && nameSplit[1].toLowerCase() == 'site') || isLocalhost){
      //console.log('Library Site Directory');
    }
  }

  ngOnInit() {
  	$('.goLib').remove();
  	$('.loding-img-main').hide();
  	if($('div').hasClass('section-two')){
  	  var countdownNumberEl = document.getElementById('countdown-number');
      var countdown = 5;
      countdownNumberEl.textContent = countdown.toString();
      setInterval(function() {
        countdown = --countdown <= 0 ? 5 : countdown;
        countdownNumberEl.textContent = countdown.toString();
      }, 1000);
  	}
  	  
  }

  findAnother(event){
  	event.preventDefault();
  	//console.log('I am clicked');
  	$('.section-two').removeClass('showI').addClass('hideI');
  	$('.section-one').addClass('showI').removeClass('hideI');
  }

  finding(event){
  //console.log(event.target.val());
  var text = $(event.target).val();
  	this.directoryService.getLibraryList(text).subscribe((data:any) => {
        //console.log(data, 'list');
      },
      (error) =>{
        //console.log(error, 'error');
      }
    );
  }

}
